import axios from 'axios'
import { showSuccess, showError } from '../../index.js'

export default {
  namespaced: true,
  state () {
    return {
      footers: []
    }
  },
  getters: {
    finalFooter (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.footers[0]
      } else {
        return state.footers[1]
      }
    },
    backendFooters (state) {
      return state.footers
    }
  },
  mutations: {
    setFooters (state, payload) {
      state.footers = payload
    }
  },
  actions: {
    async getFooterData (context) {
      await axios.get(context.rootState.API_Url + 'Footers/').then((response) => {
        const responseData = response.data
        context.commit('setFooters', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async postFooter (context, payload) {
      await context.rootState.authAxios.post('/Footers', payload
      ).then(() => {
        showSuccess('Add successfully')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    },
    async updateFooter (context, payload) {
      await context.rootState.authAxios.put(`/Footers/${payload.id}`, payload
      ).then(() => {
        showSuccess('Cập nhật thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    },
    async deleteFooter (context, payload) {
      await context.rootState.authAxios.delete(`/Footers/${payload}`
      ).then(() => {
        showSuccess('Xóa thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    }
  }
}
